export enum FreeFieldType {
	CollectionField = 0,
	ApprovalRate = 1
}